import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) =>
{
   const { isLoggedIn } = useAuth();
   const navigate = useNavigate();

   const location = useLocation();

   useEffect(() =>
   {
      if (!isLoggedIn)
      {
         navigate(`login?next=${location.pathname}${location.search}`, { replace: true });
      }
   }, [isLoggedIn, navigate, location]);

   return children;
};

AuthGuard.propTypes = {
   children: PropTypes.node
};

export default AuthGuard;
